var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9688 20.3125L20.3125 15L11.9688 9.6875V20.3125ZM15 27.5C13.2917 27.5 11.6771 27.1719 10.1563 26.5156C8.63542 25.8594 7.30729 24.9636 6.17188 23.8281C5.03646 22.6927 4.14063 21.3646 3.48438 19.8438C2.82813 18.3229 2.5 16.7083 2.5 15C2.5 13.2708 2.82813 11.6458 3.48438 10.125C4.14063 8.60417 5.03646 7.28125 6.17188 6.15625C7.30729 5.03125 8.63542 4.14063 10.1563 3.48438C11.6771 2.82813 13.2917 2.5 15 2.5C16.7292 2.5 18.3542 2.82813 19.875 3.48438C21.3958 4.14063 22.7188 5.03125 23.8438 6.15625C24.9688 7.28125 25.8594 8.60417 26.5156 10.125C27.1719 11.6458 27.5 13.2708 27.5 15C27.5 16.7083 27.1719 18.3229 26.5156 19.8438C25.8594 21.3646 24.9688 22.6927 23.8438 23.8281C22.7188 24.9636 21.3958 25.8594 19.875 26.5156C18.3542 27.1719 16.7292 27.5 15 27.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoType);
export default __webpack_public_path__ + "static/media/videoType.797e25a503540fae4d484422ede87b8e.svg";
export { ForwardRef as ReactComponent };